import { Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Map as LeafletMap } from "leaflet";

import { ButtonGrid } from "src/components/form-components/ButtonGrid";
import { ButtonLoading } from "src/components/ButtonLoading";
import { ServerErrors } from "src/components/form-components/ServerErrors";
import { APIError } from "src/types";
import { useDrawPolygon } from "src/hooks/useDrawPolygon";
import { useEffect } from "react";
import { featureToWKT } from "src/utils/geometry.utils";

interface Props {
  map: LeafletMap;
  isLoading: boolean;
  errors?: APIError[] | null;
  onCancel: () => void;
  onSubmit: (polygon_frontendSrid: string) => void;
}

export function CaseCreatePredefinedForm(props: Props) {
  const { t } = useTranslation();
  const { polygon, startDrawing, redrawDrawing: deleteDrawing, editDrawing } = useDrawPolygon(props.map);

  useEffect(() => startDrawing(), []);

  function handleSubmit() {
    if (!polygon) return;
    const polygon_frontendSrid = featureToWKT(polygon);
    props.onSubmit(polygon_frontendSrid);
  }

  return render();

  function render() {
    return (
      <Styles>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h2" color="primary">
              {t("title.createCase")}
            </Typography>

            <Typography>
              {t<string>("label.drawRegionOnTheMap")}
              {polygon && (
                <>
                  <Button color="primary" onClick={deleteDrawing}>
                    {t("label.redraw")}
                  </Button>
                  <Button color="primary" onClick={editDrawing}>
                    {t("label.edit")}
                  </Button>
                </>
              )}
            </Typography>
          </Grid>

          {props.errors && (
            <Grid item xs={12}>
              <ServerErrors data={props.errors} />
            </Grid>
          )}

          <ButtonGrid container item xs={12} sx={{ justifyContent: "flex-end" }}>
            <Button variant="text" onClick={props.onCancel} disabled={props.isLoading}>
              {t("label.previous")}
            </Button>
            <ButtonLoading
              color="primary"
              variant="contained"
              disabled={!polygon}
              onClick={handleSubmit}
              isLoading={props.isLoading}
            >
              {t("label.finish")}
            </ButtonLoading>
          </ButtonGrid>
        </Grid>
      </Styles>
    );
  }
}

const Styles = styled.div`
  .error-item {
    width: 100%;
  }
`;
